import { useUser } from "@p0security/frontend-core";
import { AppPaths } from "@p0security/shared/routes/constants";
import {
  ConfigProvider,
  Flex,
  Layout,
  Menu,
  ThemeConfig,
} from "@p0security/ui";
import React, { useContext, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { spacing } from "styles/spacing";
import { colors } from "styles/variables";

import { useIsPrint } from "../../../hooks/useIsPrint";
import { useAgenticGateway } from "../../Agentic/AgenticGateway";
import { EnvironmentDocsContext } from "../../Environment/contexts/EnvironmentDocsContext";
import { UserAuthz } from "../../Login";
import { LoggedInUserNavItem } from "../LoggedInUserNavItem";
import { newBottomItems, newSidebarItems } from "./NavbarItems";
import { P0NavIcon } from "./P0NavIcon";

const { Sider } = Layout;

const navMenuTheme: ThemeConfig = {
  components: {
    Menu: {
      itemBg: "transparent",
      itemColor: colors.neutral["50"],
      itemHoverBg: colors.neutral["10"],
      itemHoverColor: colors.neutral["70"],
      itemSelectedBg: colors.tagColors.blue.bg,
      itemSelectedColor: colors.neutral["70"],
      itemBorderRadius: spacing.radius.sm,
      itemMarginBlock: spacing.scale.sm,
      itemMarginInline: spacing.scale.sm,
      activeBarBorderWidth: 0,
      dangerItemColor: colors.tagColors.red.text,
      dangerItemHoverColor: colors.tagColors.red.text,
      dangerItemActiveBg: colors.tagColors.red.bg,
      dangerItemSelectedColor: colors.tagColors.red.text,
    },
  },
};

export const Navbar: React.FC = () => {
  const userAuthz = useContext(UserAuthz);
  const isPrint = useIsPrint();
  const { signOut } = useUser();
  const { orgSlug } = useParams();
  const { pathname } = useLocation();
  const { hasEnvironments } = useContext(EnvironmentDocsContext);
  const { hasGateway: hasAgenticGateway } = useAgenticGateway();

  const selectedNavKeys = useMemo(() => {
    const pathSegments = pathname.split("/");
    const appPath = pathSegments[3];
    return Object.values(AppPaths).filter((p) => p === appPath);
  }, [pathname]);

  if (isPrint) return null;

  const menuStyle = { background: "transparent", borderInlineEnd: "none" };

  return (
    <Sider
      width={220}
      breakpoint="lg"
      theme="light"
      /* eslint-disable-line react/forbid-component-props */ style={{
        background: colors.neutral["00"],
      }}
    >
      <ConfigProvider theme={navMenuTheme}>
        <Flex vertical className="h-full">
          <Link to={`/o/${orgSlug}`} className="block py-4 pr-10 pl-7">
            <P0NavIcon />
          </Link>
          <Flex flex={1} vertical className="overflow-auto">
            <Menu
              theme="light"
              mode="inline"
              selectedKeys={selectedNavKeys}
              /* eslint-disable-line react/forbid-component-props */ style={
                menuStyle
              }
              items={newSidebarItems(
                userAuthz,
                hasEnvironments,
                hasAgenticGateway
              )}
            />
          </Flex>
          <Flex
            vertical
            gap={spacing.scale.sm}
            /* eslint-disable-line react/forbid-component-props */ style={{
              paddingTop: spacing.scale.sm,
            }}
          >
            <LoggedInUserNavItem />
            <Menu
              mode="inline"
              theme="light"
              selectable={false}
              /* eslint-disable-line react/forbid-component-props */ style={
                menuStyle
              }
              items={newBottomItems(signOut)}
            />
          </Flex>
        </Flex>
      </ConfigProvider>
    </Sider>
  );
};
